import {NetworkStatus} from '@apollo/client';
import type {IBreadcrumbItem} from 'components/FluentUICompat';
import React, {createContext} from 'react';
import {GetRegulatoryDocumentDetailsQuery} from '../hooks/useGetRegulatoryDocumentDetails.generated';

export interface RegDocInjectedData {
	/**
	 * The pre-fetched data shaped as the regulatoryDocument query result.
	 * When provided, RegDocDetailsPage skips its own query.
	 */
	data: GetRegulatoryDocumentDetailsQuery | undefined;
	isLoading: boolean;
	networkStatus: NetworkStatus;
	/**
	 * When provided, overrides the default breadcrumbs built from the regulation.
	 */
	breadcrumbItems?: IBreadcrumbItem[];
}

export const RegDocInjectedDataContext =
	createContext<RegDocInjectedData | null>(null);
